module.exports = __webpack_public_path__ + "static/media/msg-fail.c47ee2d5.svg";